import { render, staticRenderFns } from "./RecursiveModelFactor.vue?vue&type=template&id=2b67d93e&"
import script from "./RecursiveModelFactor.vue?vue&type=script&lang=ts&"
export * from "./RecursiveModelFactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports